/**
 * Use this for math related filters.
 *
 * Usage Examples:
 *
 *      {{ 0.123 | % }}     // 12.3%
 *
 *      {{ 1.5 | round }}       // 2
 *      {{ 1.345 | round:2 }}   // 1.35
 */
define('ko/filters/mathFilters',['underscore', 'knockout'], function (_, ko) {

    ko.filters['%'] = function (value) {
        return (ko.unwrap(value) * 100) + '%';
    };

    ko.filters.round = function(value, places) {
        return _.round(ko.unwrap(value), places);
    };

});

